<template>
  <div>
    <b-card>
      <div class="d-flex mb-2">
        <div :style="{ minWidth: '75%' }">
          <b-input-group size="sm">
            <b-form-input
              :style="{ minWidth: '60%' }"
              v-model="termo_pesquisa"
              v-on:keyup.enter="loadData"
              placeholder="Pesquisar"
            ></b-form-input>
            <SelectFileCategoria
              v-model="file_categoria_id"
              placeholder="Nome"
            />
            <b-input-group-append>
              <b-button @click="loadData" variant="bagsis">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="ml-auto">
          <b-button
            size="sm"
            variant="bagsis"
            :to="{ name: 'files_create' }"
            v-if="$can('file:create') && show_btn_novo"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <Table
        :items="files"
        :fields="fields"
        :view_edit="$can('file:edit')"
        :view_delete="$can('file:delete')"
        :view_link="true"
        :max_select="max_select"
        @delete="delete_file"
        ref="table_files"
      />
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Table from "./TableList/Table.vue";
import SelectFileCategoria from "./SelectFileCategoria.vue";
import mixins from "@/components/Table/mixins";

export default {
  mixins: [mixins],

  components: { Table, SelectFileCategoria },
  props: {
    show_actions: {
      type: Boolean,
      default: true,
    },
    show_select: {
      type: Boolean,
      default: false,
    },
    show_btn_novo: {
      type: Boolean,
      default: true,
    },
    max_select: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
    file_categoria_id: null,
  }),
  computed: {
    ...mapState("files", ["files", "pagination"]),
    fields() {
      const pushItem = (condition, item) => (condition ? [item] : []);

      return [
        ...pushItem(this.show_select, { key: "select", label: "#" }),
        { key: "imagem", label: "", class: "text-center" },
        { key: "legenda", label: "Legenda" },
        { key: "path", label: "Diretório" },
        { key: "categoria.nome", label: "Categoria" },
        { key: "outros", label: "#", class: "text-center" },
        ...pushItem(this.show_actions, {
          key: "actions",
          label: "",
          class: "cell-actions",
        }),
      ];

      //fields.push({ key: "oportunidades", label: "#", class: "text-center" });
    },
  },
  methods: {
    ...mapActions("files", [
      "ActionGetAll",
      "ActionDelete",
      "ActionSetPagination",
    ]),
    async delete_file(file) {
      try {
        await this.ActionDelete(file.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    searchTerm() {
      this.pagination.current_page = 1;
      this.loadData();
      this.$router.push({
        query: {
          page: this.page,
          q: this.termo_pesquisa,
        },
      });
    },
    async loadData() {
      try {
        let payload = {
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          q: this.termo_pesquisa,
        };

        if (this.file_categoria_id) {
          payload.file_categoria_id = this.file_categoria_id;
        }

        if (this.type) {
          payload.type = this.type;
        }

        await this.ActionGetAll(payload);
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    getSelected() {
      return this.$refs.table_files.getSelected();
    },
  },
  // async created() {
  //   let pagination = {
  //     current_page: 1,
  //     per_page: 15,
  //   };
  //   if (this.$route.query.page > 1) {
  //     pagination.current_page = this.$route.query.page;
  //   }
  //   console.log('pagination', pagination)
  //   /await this.ActionSetPagination(pagination);

  //   if (this.$route.query.q != "") {
  //     this.termo_pesquisa = this.$route.query.q;
  //   }
  //   this.loadData();
  // },
};
</script>
